const EnhanceTableStyles = {
  '.singleradio': { marginLeft: '30px' },
  '.filterInput': {
    width: 'min-content',
    minWidth: '-webkit-fill-available',
    margin: '-10px -5px',
  },
  '.wordBreak': {
    wordBreak: 'break-all',
  },
  '.word_Break': {
    wordBreak: 'break-word',
  },
  '.plusMore': {
    paddingLeft: '5px',
    color: '#006FCF',
    cursor: 'pointer',
  },
  '.expandableEmptyCell': {
    borderBottom: 'none',
    borderTop: 'none',
    borderLeft: 'none',
  },
  '.expandableContent': {
    borderBottom: 'none',
    display: 'contents !important',
  },
  '.expandableCell': {
    borderTop: 'none',
    borderLeft: '0.0625rem solid #ecedee',
    wordBreak: 'break-word',
  },
  '.anchorLink': {
    cursor: 'pointer',
    color: '#006FCF',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
};

export default EnhanceTableStyles;
